import { Fullscreen, FullscreenExit } from "@mui/icons-material";
import { IconButton, SxProps, Tooltip } from "@mui/material";
import { useContext } from "react";
import TimelinePlayerContext from "../context/TimelinePlayerContext";

interface Props {
  disabled?: boolean;
  sx?: SxProps;
}

export default function ToggleFullscreen({ disabled, sx }: Props) {
  const { fullscreen, setFullscreen } = useContext(TimelinePlayerContext);

  return fullscreen ? (
    <IconButton
      disabled={disabled}
      title="Fullscreen"
      size="large"
      sx={{
        padding: 0,
        color: (theme) => theme.palette.secondary.dark,
        ...sx,
      }}
      onClick={() => setFullscreen(false)}
    >
      <Tooltip title="Exit Fullscreen">
        <FullscreenExit />
      </Tooltip>
    </IconButton>
  ) : (
    <IconButton
      disabled={disabled}
      title="Fullscreen"
      size="large"
      sx={{
        padding: 0,
        color: (theme) => theme.palette.secondary.dark,
        ...sx,
      }}
      onClick={() => setFullscreen(true)}
    >
      <Tooltip title="Enter Fullscreen">
        <Fullscreen />
      </Tooltip>
    </IconButton>
  );
}
